import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GalaxyButton, useClaim } from '@shared'

import borderSrc from '../../assets/claim-border.svg'

import styles from './ClaimRewardScreen.module.scss'

const CLAIM_DEADLINE = new Date('2026-06-09T14:00:00Z')

function getClaimCountdown() {
  const diff = Math.max(0, CLAIM_DEADLINE.getTime() - Date.now())
  const totalSeconds = Math.floor(diff / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  return [days, hours, minutes, seconds].map((n) => String(n).padStart(2, '0')).join(':')
}

type Props = {
  amount: number
  setIsClaimed: (val: boolean) => void
}

export const ClaimRewardScreen = ({ amount, setIsClaimed }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { claimJetton } = useClaim()
  const { t } = useTranslation()
  const [countdown, setCountdown] = useState(getClaimCountdown)

  useEffect(() => {
    const id = setInterval(() => setCountdown(getClaimCountdown()), 1000)
    return () => clearInterval(id)
  }, [])

  return (
    <div className={styles.frame}>
      <img
        src={borderSrc}
        alt=""
        className={styles.frameBorder}
        aria-hidden
      />

      <div className={styles.topContent}>
        <p className={styles.subtitle}>{t('rewards.timeLeft')}</p>
        <p className={styles.timer}>{countdown}</p>
      </div>
      <div className={styles.amount}>{`${amount} $NOT`}</div>

      <div className={styles.buttons}>
        <GalaxyButton
          className={`${styles.button} ${styles.buttonClaim}`}
          withGlow={false}
          disabled={isLoading}
          onClick={async () => {
            setIsLoading(true)
            const res = await claimJetton()
            setIsClaimed(res)
            setIsLoading(false)
          }}
        >
          {t('rewards.claimReward')}
        </GalaxyButton>
      </div>

      <span className={styles.comingSoon}>$NOT $NOT $NOT $NOT</span>
    </div>
  )
}
